import { useQuery } from '@tanstack/react-query';
import SeasonService from '../services/seasonService';

/**
 * React-Query hook to fetch the current season for a league.
 * @param {string} leagueId
 */
export const useGetCurrentSeason = (leagueId) => {
  return useQuery({
    queryKey: ['league-season', leagueId],
    queryFn: async () => {
      const response = await SeasonService.getCurrentSeason(leagueId);
      return response; // SeasonService already returns parsed data
    },
    enabled: !!leagueId,
    staleTime: 10 * 60 * 1000, // 10 minutes
  });
};
